import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { OutlineLargeButton, PrimaryButton } from "../../../../Constant";
import { LARGE_OUTLINE_BUTTONS, LARGE_OUTLINE_BUTTONS_LIST } from "../../../../Data/Buttons/DefaultStyle";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonButton from "../Common/CommonButton";

const OutlineLargeButtons = () => {
    const [buttonTooltip, setButttooltip] = useState(false);
    const buttonToggle = () => setButttooltip(!buttonTooltip);
    return (
      <Card>
        <CommonCardHeader title={OutlineLargeButton} span={LARGE_OUTLINE_BUTTONS} />
        <CardBody className="btn-showcase">
          <Btn size="lg" outline color="primary" id="Tooltip-54">{PrimaryButton}</Btn>
          <ToolTip target="Tooltip-54" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-outline-primary btn-lg</ToolTip>
          {LARGE_OUTLINE_BUTTONS_LIST.map((data, index) => (
            <CommonButton key={index} item={data} outline={true} size="lg"/>
          ))}
        </CardBody>
      </Card>
    );
};

export default OutlineLargeButtons;
